import React from 'react'

export default ({ date }) => {
  const splitDate = date.slice(0,10).split("-");
  return (
    <>
      {`${splitDate[1]}/${splitDate[2]}/${splitDate[0]}`}
    </>
  )
}